/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IVno {
        id: number;
        name: string;
        adminUsers: Models.IUser[];
        users: Models.IUser[];
        groups: Models.IUserGroup[];
        devices?: Models.INetworkNode[];
        logo?: string;
    }

    export class Vno implements IVno {
        public id: number;
        public name: string;
        public adminUsers: Models.IUser[];
        public users: Models.IUser[];
        public devices: Models.INetworkNode[];
        public groups: Models.IUserGroup[];
        public logo: string;

        public static removeDemiurgo(vno: Models.IVno): void {
            let i: number;
            for (i = 0; i < vno.users.length; i++)
                if (vno.users[i].username === 'demiurgo')
                    break;
            if (i !== undefined && i >= 0 && i < vno.users.length)
                vno.users.splice(i, 1);
        }

        constructor() {
            // empty constructor
        }
    }
}
